






















































































































import { isNumber } from 'lodash'
import Swal from 'sweetalert2'
import PosterUser from '../mixins/poster-user'
import { EvaluacionForm } from '../services/poster'
import Worker from './Worker.vue'

interface Data {
  clave: string | null
  text: string[] | any
  value: string | null
  titulo?: string
}

interface CriterioEval {
  titulo: string
  descripcion: string
  value?: number
}

interface ElementoEvaluacion {
  detalle: string
  ponderacion: number
  criterios: CriterioEval[]
  total: number
}

interface EvaluacionComponetData {
  posterType: string
  dialog_: boolean
  elementosEvaluacion: ElementoEvaluacion[]
  valid: boolean
  showAlert: boolean
  inputRules: any[]
}

export default PosterUser.extend({
  components: {
    Worker,
  },
  data(): EvaluacionComponetData {
    return {
      posterType: 'eval',
      dialog_: true,
      elementosEvaluacion: [
        {
          detalle: 'PRESENTACIÓN DEL PÓSTER (Ponderación 20%)',
          ponderacion: 0.2,
          total: 0,
          criterios: [
            {
              titulo: 'Elementos del póster:',
              descripcion:
                'Incluye todos los elementos requeridos, se añade otra información que apoya al contenido.',
            },
            {
              titulo: 'Etiquetas:',
              descripcion:
                'Los elementos de importancia tienen la etiqueta que puede leerse fácilmente.',
            },
            {
              titulo: 'Relevancia de las Gráficas:',
              descripcion:
                'Todas las gráficas se relacionan con el tema del proyecto y contribuyen a una comprensión más fácil. ',
            },
            {
              titulo: 'Utiliza con eficacia los recursos visuales:',
              descripcion:
                'El diseño es Atractivo. El objetivo es atraer la atención de la audiencia, pero a la vez también debe facilitar la comprensión de los datos que aparecen. La letra y las figuras deben ser claras. Las figuras han de estar justificadas y deben ser significativas.',
            },
            {
              titulo: 'Gramática:',
              descripcion: 'Clara redacción y sin errores de ortografía.',
            },
          ],
        },
        {
          detalle: 'VIDEO PRESENTACIÓN (Ponderación 20%)',
          ponderacion: 0.2,
          total: 0,
          criterios: [
            {
              titulo: 'Duración:',
              descripcion:
                'Se apega al tiempo establecido por el evento para socializar su proyecto (tiempo 5 minutos).',
            },
            {
              titulo: 'Contenido:',
              descripcion:
                'Contempla cada uno de los puntos temáticos solicitados por el evento. Los contenidos muestran una secuencia lógica.',
            },
            {
              titulo: 'Audio:',
              descripcion:
                'El audio del video es claro con un volumen adecuado, usa un vocabulario adecuado, no se evidencian errores de dicción.',
            },
            {
              titulo: 'Video:',
              descripcion:
                'El video es claro, cuenta con buena iluminación y presenta una excelente edición',
            },
            {
              titulo: 'Originalidad:',
              descripcion: 'Completamente auténtico y ameno en su guion',
            },
          ],
        },
        {
          detalle: 'COHERENCIA EN EL CONTENIDO DEL PÓSTER (Ponderación 30%)',
          ponderacion: 0.3,
          total: 0,
          criterios: [
            {
              titulo: 'Identificadores:',
              descripcion:
                'Nombre de la universidad, logotipo, nombre del programa académico, nombre y fecha del evento, integrantes (director y estudiantes), semillero al que pertenece.',
            },
            {
              titulo: 'Descripción del propósito:',
              descripcion:
                'presenta una redacción clara y concisa del trabajo presentado.',
            },
            {
              titulo: 'Redacción de los Objetivos:',
              descripcion:
                'los objetivos son claros y definen el alcance del proyecto. ',
            },
            {
              titulo: 'Imágenes:',
              descripcion:
                'Éstas se disponen en el diagrama central, o a manera de resultados en la sección correspondiente. Están articuladas al objeto de estudio.',
            },
            {
              titulo: 'Conclusiones:',
              descripcion:
                'Las conclusiones expresan de manera adecuada la argumentación del proceso de investigación y de los hallazgos/resultados.',
            },
          ],
        },
        {
          detalle: 'ARGUMENTACIÓN (Ponderación 30%)',
          ponderacion: 0.3,
          total: 0,
          criterios: [
            {
              titulo: 'Expone el Objetivo:',
              descripcion:
                'Indica a la audiencia de forma clara cuál es el objetivo del proyecto: de qué información se dispone, a donde se ha querido llegar, cual es la posible pregunta de investigación, etc. También se indica cuál ha sido el resultado.',
            },
            {
              titulo: 'Indica el desarrollo seguido para llegar al objetivo:',
              descripcion:
                'Es el espacio destinado a mostrar de forma resumida qué camino se ha seguido a fin de llegar a los objetivos: metodologías, modelos de desarrollo, gráficos, texto. ',
            },
            {
              titulo: 'Respuestas a Preguntas',
              descripcion:
                'de los Jurados. Las respuestas y argumentaciones dadas son apropiadas.',
            },
          ],
        },
      ],
      valid: false,
      showAlert: false,
      inputRules: [
        (v: any) => !!v || 'ingrese un valor',
        (v: any) => (1 <= v && v <= 10) || 'rango 1-10',
        (v: any) => /^([0-9])*$/.test(v) || 'solo números',
      ],
    }
  },

  computed: {
    values(): any {
      const { elementosEvaluacion } = this as any
      return [
        ...(elementosEvaluacion as ElementoEvaluacion[]).map(e => {
          return [
            ...e.criterios.map((c: any) =>
              /^\d+$/.test(c.value) ? parseInt(c.value) : 0
            ),
          ]
        }),
      ]
    },
    form(): any {
      if (!this.poster) {
        return {}
      }
      const { elementosEvaluacion } = this as any
      const calificacion = [
        ...(elementosEvaluacion as ElementoEvaluacion[]).map(
          e => e.total * e.ponderacion
        ),
      ].reduce((a: number, b: number) => a + b, 0)
      return {
        calificacion,
        id_evaluador_poster: (this as any).poster.evaluacion
          .id_evaluador_poster,
      } as EvaluacionForm
    },

    postEvaluacion() {
      const { poster } = this
      return poster && (poster.estado === 'A' || poster.estado === 'N')
    },
  },

  methods: {
    async save() {
      if (!(this as any).valid) {
        this.showAlert = true
        setTimeout(() => {
          this.showAlert = false
        }, 5000)
      } else {
        await this.sync()
        const { form, poster } = this
        try {
          const result = await this.$store.dispatch('poster/evaluacionPoster', {
            form,
            poster,
          })
          Swal.fire('Exito', result, 'success')
          ;(this as any).visible = false
        } catch (error) {
          Swal.fire('Error', 'No fue posible realizar cambios', 'error')
        }
      }
    },
  },
  watch: {
    values(v: any[]) {
      const { elementosEvaluacion } = this as any
      for (let i = 0; i < v.length; i++) {
        const valuesElemento = v[i]
        const total = valuesElemento.reduce((a: number, b: number) => a + b, 0)
        elementosEvaluacion[i].total = total / valuesElemento.length
      }
    },
    poster() {
      ;(this.$refs.form as any).reset()
      ;(this.$refs.form as any).resetValidation()
    },
  },
})
